import React from 'react';
import { TableQuery } from '../../../../../gen-src/queries';
import { SelectionProviderChildProps, VerticalFlexContainer } from '../../../data-catalog-shared';
import { PaneWithTitle } from '../placePage/PaneWithTitle';
import { ColumnsGridSortProvider } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { containerClass, SingleSelectionControls } from '../widgets/SingleSelectionControls';
import { ColumnActionsMenu } from './ColumnActionsMenu';
import { TableColumnsQueryGrid } from './TableColumnsQueryGrid';
import { TableDetails } from './TableDetails';


export interface TableColumnsPaneProps extends SelectionProviderChildProps {
  readonly title: string;
  readonly table: Unpacked<TableQuery['tables']>;
  readonly tableId: string;
  readonly rowCount: number | null;
  readonly hackyUpdateNumber: number;
}
export function TableColumnsPane(props: TableColumnsPaneProps): JSX.Element {

  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <TableDetails table={props.table} />
      <PaneWithTitle title={props.title}>
        <VerticalFlexContainer fillFlexParent={true}>
          <span className={containerClass}>
            <SingleSelectionControls
              selectedKeys={props.selectedKeys}
              updateSelectionForKey={props.updateSelectionForKey}
              clearSelection={props.clearSelection}
            />
            <ColumnActionsMenu
              columnIds={props.selectedKeys}
              tableVizportalId={props.table.__typename === 'DatabaseTable' ? props.table.vizportalId : null}
            />
          </span>

          <ColumnsGridSortProvider>
            {({ orderBy, updateSortOrder }) =>
              <TableColumnsQueryGrid
                tableId={props.tableId}
                tableVizportalId={props.table.__typename === 'DatabaseTable' ? props.table.vizportalId : ''}
                orderBy={orderBy}
                selectedKeys={props.selectedKeys}
                updateSelectionForKey={props.updateSelectionForKey}
                updateSortOrder={updateSortOrder}
                rowCount={props.rowCount}
                hackyUpdateNumber={props.hackyUpdateNumber}
              />
            }
          </ColumnsGridSortProvider>
        </VerticalFlexContainer>
      </PaneWithTitle>
    </VerticalFlexContainer>
  );
}
